import { useState, useEffect } from 'react';

export const useDetectOverlap = <T extends HTMLElement>(
  leftElement: T | null,
  rightElement: T | null
) => {
  const [isOverlapping, setIsOverlapping] = useState(false);

  useEffect(() => {
    if (
      !leftElement ||
      !rightElement ||
      typeof ResizeObserver === 'undefined'
    ) {
      return;
    }

    const checkOverlap = () => {
      const leftRect = leftElement.getBoundingClientRect();
      const rightRect = rightElement.getBoundingClientRect();
      setIsOverlapping(leftRect.right >= rightRect.left);
    };

    checkOverlap();

    const observer = new ResizeObserver(checkOverlap);
    observer.observe(leftElement);
    observer.observe(rightElement);

    return () => observer.disconnect();
  }, [leftElement, rightElement]);

  return isOverlapping;
};
